import styled from 'styled-components';

import { ContentSwitcher } from '@xing-com/content-switcher';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXXL, space3XL } from '@xing-com/tokens';

const ButtonNavigationContentSwitcher = styled(ContentSwitcher)`
  margin: 0 0 ${spaceXXL};

  @media ${mediaConfined} {
    margin-top: ${space3XL};
  }
`;

export const Styled = {
  ButtonNavigationContentSwitcher,
};
